import { object, string, array, func, shape } from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

// Import hooks
import { useAppSelector } from 'store/hooks';

// Import actions
import { fetchPlayerConfig, deleteVideoSession, setSelectedProgram, playerOnCancel } from 'store/actions';

// Import components
import NoImage from 'components/views/vod/images/placeholder.svg';

// Import styles
import { Wrapper, Box, Preview, Image, Content, ProductName, ButtonStyled, TrashIconStyled } from './style';

// Import helpers
import { createLinkParams, getImage } from 'helpers';
import { sendChannelEvent } from 'helpers/tracking';

// Import utilities
import { ImageOnLoadRPC } from 'components/utilities';

// Import variables
import { PLAYER_SELECTORS, ROUTES_CORE_PATHS, PRODUCTS_TYPES, PRODUCT_IMAGES_TYPES } from 'helpers/variables';

const { CHANNEL } = PRODUCTS_TYPES;
const { POSTER, COVER, LOGO, LOGO_INVERTED } = PRODUCT_IMAGES_TYPES;

const Favourite = ({
	item: { images, title, uuid: id, type, subtype, genres },
	toggle,
	deleteFavourite,
	fetchPlayerConfig,
	deleteVideoSession,
	setSelectedProgram,
	playerOnCancel
}) => {
	const history = useHistory();
	const { pathname } = useLocation();
	const isTelevisionPage = pathname.includes(ROUTES_CORE_PATHS.TELEVISION);
	const isChannel = subtype === CHANNEL;

	// Check if player config has loaded
	const { isLoaded, videoSessionId } = useAppSelector((state) => state.player);

	const imgUrl = getImage({
		images,
		types: type === CHANNEL ? [LOGO, LOGO_INVERTED] : [POSTER, COVER]
	});

	const handleRedirect = () => {
		if (isChannel) {
			const toggleTime = isTelevisionPage ? 1000 : 20;
			setTimeout(() => toggle(), toggleTime);
			isTelevisionPage
				? isLoaded && handlePlaySelected()
				: history.push(`/tv/${ROUTES_CORE_PATHS.TELEVISION}`, {
						channelId: id
					});
		} else {
			setTimeout(() => toggle(), 20);
			history.push(createLinkParams({ id, type: subtype, title }));
		}
	};

	const handlePlaySelected = async () => {
		// delete request
		playerOnCancel(PLAYER_SELECTORS.PLAYER);
		// delete video session
		videoSessionId && (await deleteVideoSession());
		// set title in player overlay content
		setSelectedProgram(null, id);
		// fetch new session config
		fetchPlayerConfig({ uuid: id });

		sendChannelEvent({ url: pathname, genres, item_name: title });
	};

	return (
		<Wrapper>
			<Box onClick={handleRedirect} isLoaded={isLoaded} isTelevisionPage={isTelevisionPage}>
				<Preview>
					<ImageOnLoadRPC ignoreError>
						{({ setError, isError }) => <Image src={isError || !imgUrl ? NoImage : imgUrl} onError={setError} effect="blur" />}
					</ImageOnLoadRPC>
				</Preview>
				<Content>{title && <ProductName>{title}</ProductName>}</Content>
			</Box>
			<ButtonStyled onClick={() => deleteFavourite(id)}>
				<TrashIconStyled />
			</ButtonStyled>
		</Wrapper>
	);
};

Favourite.propTypes = {
	deleteFavourite: func.isRequired,
	toggle: func.isRequired,
	item: shape({
		images: object,
		title: string,
		uuid: string.isRequired,
		type: string.isRequired,
		subtype: string.isRequired,
		genres: array,
		available_in: array
	}).isRequired,
	fetchPlayerConfig: func.isRequired,
	deleteVideoSession: func.isRequired,
	setSelectedProgram: func.isRequired,
	playerOnCancel: func.isRequired
};

export default connect(null, {
	fetchPlayerConfig,
	deleteVideoSession,
	setSelectedProgram,
	playerOnCancel
})(Favourite);
